/**
 * Fase 3: Cookie storage for anonymous quotation request (request_id and anonymous_id).
 * Only used when user is NOT logged in. Logged-in users use lead_id on the backend.
 */

const REQUEST_ID_COOKIE = 'store-quotation-request-id';
const ANONYMOUS_ID_COOKIE = 'store-quotation-anonymous-id';
const COOKIE_MAX_AGE_DAYS = 30;
const COOKIE_PATH = '/';

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string): void {
  if (typeof document === 'undefined') return;
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=${COOKIE_PATH}; max-age=${maxAge}; SameSite=Lax`;
}

export function getRequestIdFromCookie(): string | null {
  return getCookie(REQUEST_ID_COOKIE);
}

export function setRequestIdCookie(requestId: string): void {
  setCookie(REQUEST_ID_COOKIE, requestId);
}

export function getOrCreateAnonymousId(): string {
  let id = getCookie(ANONYMOUS_ID_COOKIE);
  if (!id) {
    id = crypto.randomUUID?.() ?? `anon-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    setCookie(ANONYMOUS_ID_COOKIE, id);
  }
  return id;
}

export function clearQuotationRequestCookies(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${REQUEST_ID_COOKIE}=; path=${COOKIE_PATH}; max-age=0`;
  document.cookie = `${ANONYMOUS_ID_COOKIE}=; path=${COOKIE_PATH}; max-age=0`;
}
